export function isElementVisibleOnDom(el: HTMLElement): boolean {
	if (!el) {
		return false;
	};

	const isVisible = !isDisplayNone(el) && checkElementOpacity(el) && checkDimensions(el) && checkFontSize(el) && checkVisibility(el);

	return isVisible;
}

function checkVisibility(el: HTMLElement): boolean {
	const style = window.getComputedStyle(el);

	if (style.visibility === 'hidden' || style.visibility === 'collapse') {
		return false;
	}

	if (el.tagName === 'VIDEOGULAR' || !el.parentElement) {
		return true;
	}

	return checkVisibility(el.parentElement);
}

export function isDisplayNone(el) {
	const style = window.getComputedStyle(el);

	if (style.display === 'none') {
		return true;
	}

	if (el.tagName === 'VIDEOGULAR' || !el.parentElement) {
		return false;
	}

	return isDisplayNone(el.parentElement);
}

export function checkElementOpacity(el: HTMLElement): boolean {
	const opacity = parseFloat(window.getComputedStyle(el).opacity);

	if (opacity === 0) {
		return false;
	}

	if (el.tagName === 'VIDEOGULAR' || !el.parentElement) {
		return true;
	}

	return checkElementOpacity(el.parentElement);
}

export function getDomElement(id: string): HTMLElement {
	return document.getElementById(id);
}

export function normalizeHtml(html: string): string {
	if(!html) {
		return;
	}
	// Replace single quotes with double quotes
	let normalized = html.replace(/'/g, '"');

	// Remove all unnecessary whitespace (tabs, newlines) between tags
	normalized = normalized.replace(/\s*(<[^>]+>)\s*/g, '$1').trim();

	return normalized;
}

export function checkDimensions(el: HTMLElement): boolean {
	const style = window.getComputedStyle(el);
	const width = parseFloat(style.width);
	const height = parseFloat(style.height);

	// If the element has zero width or height and Videogular element is visible then return false.
	// if Videogular element element is not visible then height / width = 0 could be because of external factor (sidebar opening).
	if ((width === 0 || height === 0) && isVideogularVisible()) {
		return false;
	}

	// if reach til VIDEOGULAR element then return true. no need to go further up.
	if (el.tagName === 'VIDEOGULAR' || !el.parentElement) {
		return true;
	}

	return checkDimensions(el.parentElement);
}

export function checkFontSize(el: HTMLElement): boolean {
	const style = window.getComputedStyle(el);
	const fontSize = parseFloat(style.fontSize);

	if (fontSize === 0) {
		return false;
	}

	if (!el.parentElement) {
		return true;
	}

	return checkFontSize(el.parentElement);
}


function isVideogularVisible(): boolean {
	const videogularEle = document.getElementsByTagName('videogular')[0];
	const style = window.getComputedStyle(videogularEle);
	const width = parseFloat(style.width);
	const height = parseFloat(style.height);

	if (width === 0 || height === 0) {
		return false;
	}
	return true;


}
